import React, { useState } from 'react';
import { useFamilyRelationships } from '../../hooks/useFamilyRelationships';

const AddFamilyMemberModal = ({ 
  isOpen, 
  onClose, 
  mode, // "spouse", "child", "parent", "child_both_parents"
  existingPersonId,
  parent1Id, // For two-parent child creation
  parent2Id, // For two-parent child creation
  onSuccess 
}) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    gender: 'unknown',
    living: true,
    dateOfBirth: '',
    privacyLevel: 'family'
  });

  const { addRelatedPerson, addChildToBothParents, loading, error, clearError } = useFamilyRelationships();

  const handleSubmit = async (e) => {
    e.preventDefault();
    clearError();

    try {
      let result;
      const newPersonData = {
        first_name: formData.firstName,
        last_name: formData.lastName,
        gender: formData.gender,
        living: formData.living,
        date_of_birth: formData.dateOfBirth || undefined,
        privacy_level: formData.privacyLevel
      };

      switch (mode) {
        case 'spouse':
          result = await addRelatedPerson(existingPersonId, 'spouse', newPersonData);
          break;

        case 'parent':
          result = await addRelatedPerson(existingPersonId, 'parent', newPersonData); // add parent
          break;

        case 'child':
          result = await addRelatedPerson(existingPersonId, 'child', newPersonData); // add child
          break;

        case 'child_both_parents':
          result = await addChildToBothParents(parent1Id, parent2Id, newPersonData);
          break;

        default:
          throw new Error('Invalid mode');
      }

      onSuccess(result);
      onClose();
      setFormData({ firstName: '', lastName: '', gender: 'unknown', living: true, dateOfBirth: '', privacyLevel: 'family' });

    } catch (err) {
      console.error('Failed to add family member:', err);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Add {mode === 'child_both_parents' ? 'Child' : mode}</h2>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>First Name *</label>
            <input
              type="text"
              value={formData.firstName}
              onChange={(e) => setFormData(prev => ({ ...prev, firstName: e.target.value }))}
              required
            />
          </div>

          <div className="form-group">
            <label>Last Name *</label>
            <input
              type="text"
              value={formData.lastName}
              onChange={(e) => setFormData(prev => ({ ...prev, lastName: e.target.value }))}
              required
            />
          </div>

          <div className="form-group">
            <label>Gender</label>
            <select
              value={formData.gender}
              onChange={(e) => setFormData(prev => ({ ...prev, gender: e.target.value }))}
            >
              <option value="unknown">Unknown</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </select>
          </div>

          <div className="form-group">
            <label>
              <input
                type="checkbox"
                checked={formData.living}
                onChange={(e) => setFormData(prev => ({ ...prev, living: e.target.checked }))}
              />
              Living
            </label>
          </div>

          <div className="form-group">
            <label>Date of Birth</label>
            <input
              type="date"
              value={formData.dateOfBirth}
              onChange={(e) => setFormData(prev => ({ ...prev, dateOfBirth: e.target.value }))}
            />
          </div>

          <div className="form-actions">
            <button type="button" onClick={onClose} disabled={loading}>
              Cancel
            </button>
            <button type="submit" disabled={loading}>
              {loading ? 'Creating...' : `Add ${mode === 'child_both_parents' ? 'Child' : mode}`}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddFamilyMemberModal;